<template>
    <div>
      <b-row>
          <b-col lg="12">
              <div v-if="loading">
              <loader></loader>
              </div>
              <b-button block v-b-toggle.collapse-locations
                      class="font-weight-bold p-1 border"
                      variant="light"
                      @click="toggleCollapse"
              >

                  <h5 class="bg-light my-1 text-center font-weight-bold">
                      <i class="float-left fa fa-caret-square-o-down"/>
                      <i class="fa fa-map-marker"/>
                      UBICACIONES
                  </h5>
              </b-button>
          </b-col>
                   <b-col lg="12">
            <b-collapse 
              id="collapse-locations" 
              class="mt-2"
              @show="onCollapseShow"
              @hide="onCollapseHide"
            >
              <b-card class="mt-2">
                <center>
                  <b-form-group label="Filtrar" horizontal>
                    <b-form-input v-model="filterText" />
                  </b-form-group>
              
                 
                  <div v-if="filteredUbicaciones.length > 0">
                    <p class="text-muted text-start">
                      Total ubicaciones: {{ filteredUbicaciones.length }}
                    </p>

                  <h6 class="text-muted text-start mt-3">
                  {{ acls.info_empresa.nombre }}
                   </h6>
                    <div class="location-details">
                      <div v-for="(id, index) in filteredUbicaciones" :key="index" class="location-item">
                        <i class="fa fa-map-marker-alt location-icon"></i>
                        <span class="location-path">
                          {{ formatLocationPath(id) }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    No hay ubicaciones asignadas.
                  </div>
                </center>
              </b-card>
            </b-collapse>
          </b-col>
      </b-row>
    </div>
  </template>

  <script>
  import { mapState, mapActions, mapMutations } from "vuex";
  import { getAcls } from "../../../plugins/acl";
  import loader from './../../../containers/loader';

  export default {
    name: "BasesAreasEmpresa",
    props: {
      editProducts: {
        type: Boolean,
        default: true
      }
    },
    data: function () {
      return {
        filterText: "",
        loading: false,
        collapseOpen: false,
        defaultProps: {
          label: 'label',
          children: 'children',
          disabled: (data) => {
            return true
          }
        },
        datos: {},
        acls: "",
        selecionadosIds: [],
        selecUbicaciones: [],
        initialSelection: [],
      };
    },
    async created() {
      this.acls = getAcls();
    },
    computed: {
      ...mapState("productos_emp", [
        "ubicaciones",
        "seleccionado",
        "marcados",
        "ubicacionesContratista",
      ]),
      filteredUbicaciones() {
    if (!this.filterText) {
      return this.selecionadosIds; 
    }

    const filterTextLower = this.filterText.toLowerCase();

    return this.selecionadosIds.filter((id) => {
      const locationPath = this.formatLocationPath(id).toLowerCase();
      return locationPath.includes(filterTextLower);
    });
  },
    },
    components: {
      loader
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    methods: {
      toggleCollapse() {
        this.collapseOpen = !this.collapseOpen
      },
      
      onCollapseShow() {
        this.collapseOpen = true
        this.getUbicaciones()
      },
      
      onCollapseHide() {
        this.collapseOpen = false
      },
      
      filterNode(value, data) {
        if (!value) return true;
        return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      },
      async getUbicaciones() {
          this.datos.producto = this.$route.params.id;
          this.datos.empresa = this.acls.empresa;
          this.datos.esEmpresa = 1;

          this.loading = true;
          await this.getUbicacionEmpresa(this.datos);
          this.setChecked(this.ubicaciones);
          if (this.editProducts) {
            await this.getUbicacionEmpresa(this.datos);
          }
          this.loading = false;
        this.selecionadosIds = [];
        this.pusherSeleccionados(this.ubicaciones);
      },
      pusherSeleccionados(data) {
        let ubicaciones = data;
        ubicaciones.forEach((element) => {
          if (element.hasOwnProperty("get_product")) {
            if (element.get_product.length > 0) {
              element.get_product.forEach((el) => {
                if (el.id_producto == this.datos.producto) {
                  this.selecionadosIds.push(element.id);
                }
              });
            }
          }
          if (element.children.length) {
            this.pusherSeleccionados(element.children);
          }
        });
        this.initialSelection = [...new Set(this.selecionadosIds)];
      },

      async setChecked(ubicacion) {
        ubicacion.map((i) => {
          if (i.checked) {
            this.seleccionados(i.id);
          }
          this.setChecked(i.children);
        });
      },
      formatLocationPath(id) {
        let path = [];
      
        const findNode = (nodes, id) => {
          for (let node of nodes) {
            if (node.id === id) {
              return node;
            }
            if (node.children && node.children.length > 0) {
              const found = findNode(node.children, id);
              if (found) return found;
            }
          }
          return null;
        };
      
        let current = findNode(this.ubicaciones, id);
      
        while (current) {
          path.unshift(current.label); 
          current = findNode(this.ubicaciones, current.slq_location_id); 
        }
        
        if (path[0] === this.acls.info_empresa.nombre) {
          path.shift();
        }
      
        return path.join(" > ");
      },
      ...mapActions("productos_emp", ["getBasesAreasEmpresa", "getUbicacionEmpresa"]),
      ...mapMutations("productos_emp", [
        "seleccionados",
        "setSeleccionados",
        "setSeleccionados",
      ]),
    },
  };
  </script>

  <style>

  .el-tree-company .el-checkbox.is-disabled.is-checked .el-checkbox__inner {
    background-color: #097b83;
    border-color: #097b83;
  }


  </style>

  <style scoped>
  .checkbox-contratista .el-checkbox__inner {
    background-color: #5eb7bd !important;
    border-color: #5eb7bd !important;
    color: #fff;
  }

  @media screen and (max-width: 400px){
  span.custom-tree-node span{
    font-size: .55rem;
  }
  }

  h6.text-muted {
  display: flex;
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 10px;
}
.location-details {
  display: flex;
  flex-direction: column; 
  gap: 10px;
  max-width: 100%; 
}

.location-item {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.location-path {
  color: #606266;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; 
}

  </style>
